module.exports = __webpack_public_path__ + "static/media/logoAlt.dfe8a205.svg";